import { render, staticRenderFns } from "./FinalReports.vue?vue&type=template&id=f2bf6672&scoped=true"
import script from "./FinalReports.vue?vue&type=script&lang=js"
export * from "./FinalReports.vue?vue&type=script&lang=js"
import style0 from "./FinalReports.vue?vue&type=style&index=0&id=f2bf6672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bf6672",
  null
  
)

export default component.exports